/**
 * Format sensor type for display
 * Converts formats like "vibrating-wire" or "vibrating_wire" to "Vibrating Wire"
 * 
 * @param type - The sensor type string (e.g., "vibrating-wire", "vibrating_wire")
 * @returns Formatted string (e.g., "Vibrating Wire") or "N/A" if type is empty/null
 * 
 * @example
 * formatSensorType("vibrating-wire") // Returns "Vibrating Wire"
 * formatSensorType("vibrating_wire") // Returns "Vibrating Wire"
 * formatSensorType("mems") // Returns "MEMS"
 * formatSensorType(null) // Returns "N/A"
 */

/** Acronyms / fixed labels — DB may store lowercase slugs; UI shows canonical form. */
const SENSOR_TYPE_DISPLAY_OVERRIDES: Record<string, string> = {
  mems: "MEMS",
};

const normalizeSensorTypeKey = (type: string): string =>
  type.trim().replace(/[-_\s]/g, "").toLowerCase();

export const formatSensorType = (type?: string | null): string => {
  if (!type) return "N/A";

  const override = SENSOR_TYPE_DISPLAY_OVERRIDES[normalizeSensorTypeKey(type)];
  if (override) return override;

  return type
    .replace(/[-_]/g, " ")
    .split(" ")
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

